import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Descriptions, Divider, Modal, Spin } from "antd";
import { Col, Row } from "react-bootstrap";
import { bancos } from "../helpers/dataBancos";
import { extracts_transm, extractt_servicio } from '../helpers/extractDataRef';
import { fetchPersonal } from "helpers/fetch";
import { createPDF } from "helpers/createpdf";
import ButtonsBancos, { Bbva } from "components/ui/buttonsBancos";
import '../globals.css';
import '../test.css';
import Error from "./Error/Error";
import { createPermitionProvitional } from "helpers/createPermisoProvi";
import { createPermisoMunicipio } from "helpers/permisoMunicipio";
import informationPermiso from "services/permiso";

const useQuery = () => new URLSearchParams(useLocation().search);
const { santander } = bancos;

const Home = () => {
  const ref = useQuery().get('ref');
  const cart = useQuery().get('cart');
  const permisoEstimulado = useQuery().get('permiso');
  const op = 'pp'
  const serie = useQuery().get('serie');
  const municipio = useQuery().get('municipio');
  const folio = useQuery().get('folio');

  const [dataForm, setDataForm] = useState({
    t_importe: '',
    val_1: '',
    val_2: ''
  })

  const [data, setData] = useState({});

  const [loadingData, setLoadingData] = useState(true);
  const [error, setError] = useState({ error: false, message: '' });
  const [isHojaMillar, setIsHojaMillar] = useState(false);

  useEffect(() => {
    if (serie) {
      permission({ op, serie, ref, permisoEstimulado });
      return;
    }

    if (municipio) {
      permissionMunicipio();
      return;
    }

    if (!ref || !RegExp(/\d{20}/).test(ref)) return;

    async function getDataRef() {
      const valHospedaje = ['0', '001', '003', '002'];
      const resp = await fetchPersonal(
        'recaudacion/esefinagetwserv.php?Oficina=TRAMITES&Peticion=ReferenciaNoPagada&Referencia=' + ref,
      );
      if (resp.status !== 200) {
        const message = (await resp.json()).detalle;
        setError({ error: true, message: message });
        return;
      }

      const { datosRecibo, arCuentas, referencia } = await resp.json();

      let claveHojaMillar = '';
      setIsHojaMillar(arCuentas.filter(e => e.cuentas?.filter(c => {
        if (c.clvFuenteIngreso.trim() === '58444' || c.clvFuenteIngreso.trim() === '58461') {
          claveHojaMillar = c.clvFuenteIngreso;
          return true;
        }
        return false;
      }).length > 0).length > 0);

      const hospedaje = ref.substr(0, 3);
      setDataForm({
        t_importe: referencia.importe.split('.')[0] + '.00',
        val_1: hospedaje === '003' ? valHospedaje[parseInt(datosRecibo.zonaHospedaje)] : '0',
        val_2: datosRecibo.contribuyentes
      })

      let convenioSant =
        referencia.tipoImpuesto === '018'
          ? santander.convenio2
          : santander.convenio;

      if (isHojaMillar) {
        convenioSant = claveHojaMillar === '58444' ? santander.convenio3 : santander.convenio4
      }

      setData({ datosRecibo, arCuentas, referencia, convenioSant });
      setLoadingData(false);
    }

    getDataRef();
  }, [ref, serie]);

  const permission = async (data) => {
    setLoadPdf(true);
    const resp = await fetchPersonal(
      'Tenencia/ModuloExterno/drive/PermisoProvDrive.php',
      data,
      'POST'
    );
    const json = await resp.json();
    json.permisoEstimulado = data.permisoEstimulado;
    await createPermitionProvitional(json);
    setLoadPdf(false);
  }

  const permissionMunicipio = async () => {
    setLoadPdf(true);
    const resp = await informationPermiso({ serie, referencia: ref, municipio, folio });

    if (!resp.acept) {
      setError({ error: true, message: resp.message })
      setLoadPdf(false);
      return;
    }
    await createPermisoMunicipio({ ...resp.body, referencia: ref, folio });
    setLoadPdf(false);
  }

  const s_transm = extracts_transm(!ref ? '' : ref);
  const t_servicios = extractt_servicio(!ref ? '' : ref);

  const [LoadPdf, setLoadPdf] = useState(false);

  const loadPDF = async () => {
    if (ref.startsWith('086')) {
      window.location.href = `https://esefina.ingresos-guerrero.gob.mx/recaudacion/construccion/hojareferenciada5millar.php?referencia=${ref}`;
      return;
    }

    setLoadPdf(true);
    await createPDF(data, ref, data.referencia.tipoImpuesto !== null && data.referencia.tipoImpuesto === '018');
    setLoadPdf(false);
  }

  if (!ref || error.error)
    return (
      <Error message={error.message} />
    );

  if (!RegExp(/\d{20}/).test(ref)) {
    return (
      <div>
        Referencia no valida
      </div>
    );
  }

  if (loadingData) {
    return (<div>cargando...</div>);
  }

  return (
    <div className='main'>
      <Row className='justify-content-md-center'>
        <Col lg='6' className='container-resalt'>
          <Descriptions
            column={2}
            size='small'
            title='Datos de referencia'
            contentStyle={{ fontWeight: 'bold' }}
          >
            <Descriptions.Item label='Referencia'>{ref}</Descriptions.Item>
            <Descriptions.Item label='Total a pagar'>{'$' + data.referencia.importe}</Descriptions.Item>
            <Descriptions.Item label='Contribuyente'>{data.datosRecibo.contribuyentes}</Descriptions.Item>
            <Descriptions.Item label='RFC'>{data.datosRecibo.rfc}</Descriptions.Item>
            <Descriptions.Item label='Fecha limite' labelStyle={{ color: 'red' }} contentStyle={{ color: 'red' }} >{data.referencia.fechaLimite}</Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Divider />
      <Row className='justify-content-center'>
        <Col sm='7'>
          <div className='title container-resalt'>
            <h5>Pago en ventanilla</h5>
            <p>
              Para realizar el pago en ventanilla bancaria, imprima su
              "Hoja de Pago Referenciado". Una vez realizado el pago en ventanilla bancaria,
              podr&aacute; consultar e imprimir su comprobante electr&oacute;nico despu&eacute;s
              de 3 d&iacute;as h&aacute;biles.
            </p>
            <p >
              SI REALIZA PAGOS CON CHEQUE, SE DEBER&Aacute;N DE REALIZAR EN UNA SOLA EXHIBICI&Oacute;N
            </p>
          </div>
        </Col>
      </Row>
      <Row className='justify-content-center text-center align-items-center'>
        <Col sm='1' >
          <button onClick={loadPDF} disabled={LoadPdf}>
            <div className='button-white-pdf'>
              <div className='btn-pdf'>
                {LoadPdf ? <Spin /> : 'Imprimir PDF'}
              </div>
            </div>
          </button>
        </Col>
      </Row>
      {
        !cart && <div>
          {!isHojaMillar && <Row className='justify-content-md-center'>
            <Col sm='7'>
              <h5>Pago con tarjeta credito/debito </h5>
            </Col>
            <Row className='justify-content-md-center' >
              <Bbva
                isAyuntamiento={data.referencia.tipoImpuesto !== null && data.referencia.tipoImpuesto === '018'}
                dataBBVA={{ s_transm, ref, t_servicios, dataForm }}
              />
            </Row>
          </Row>
          }
          <Row className='justify-content-md-center'>
            <Col sm='7'>
              <div className='title' style={{ marginTop: '10px' }}>
                <h6>Portales de pago</h6>
              </div>
            </Col>
          </Row>
          <ButtonsBancos
            isAyuntamiento={data.referencia.tipoImpuesto === '018'}
            isHojaMillar={isHojaMillar}
            dataSant={{ t_importe: data.referencia.importe, convenio: data.convenioSant, ref }}
            dataBBVA={{ s_transm, ref, t_servicios, dataForm }}
          />
        </div>
      }
    </div>
  );
}
export default Home;